import { render, staticRenderFns } from "./LuckDrawRecord3.vue?vue&type=template&id=12d8583d&scoped=true&"
import script from "./LuckDrawRecord3.vue?vue&type=script&lang=js&"
export * from "./LuckDrawRecord3.vue?vue&type=script&lang=js&"
import style0 from "./LuckDrawRecord3.vue?vue&type=style&index=0&id=12d8583d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8583d",
  null
  
)

export default component.exports